export default "__VITE_ASSET__DJfPp1$t__"